import DataVStatistic from './statistic';
export default DataVStatistic;
